import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './ProfilePhoneNumber.css';

const ProfilePhoneNumber: React.FC = () => {
  const navigate = useNavigate();
  const [phoneNumber, setPhoneNumber] = useState('+1234567890');

  const handleSave = () => {
    // Handle save logic here
    console.log('Saving phone number:', phoneNumber);
    // Navigate back after save
    navigate('/profile-security');
  };

  const handlePhoneNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // Allow only numbers and + symbol
    const value = e.target.value;
    if (value === '' || /^[+\d]*$/.test(value)) {
      setPhoneNumber(value);
    }
  };

  return (
    <div className="profile-phone-number-container">
      {/* Header */}
      <div className="profile-phone-number-header">
        <button className="profile-phone-number-back-button" onClick={() => navigate('/profile-security')}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
        <h1 className="profile-phone-number-header-title">Phone Number</h1>
      </div>

      {/* Form Content */}
      <div className="profile-phone-number-content">
        {/* Phone Number Field */}
        <div className="profile-phone-number-field">
          <label className="profile-phone-number-label">Phone number</label>
          <div className="profile-phone-number-input-wrapper">
            <input
              type="tel"
              className="profile-phone-number-input"
              value={phoneNumber}
              onChange={handlePhoneNumberChange}
              placeholder="+1234567890"
            />
          </div>
        </div>

        {/* Save Button */}
        <button className="profile-phone-number-save-button" onClick={handleSave}>
          Save
        </button>
      </div>
    </div>
  );
};

export default ProfilePhoneNumber;